import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/features/auth/auth-context'
import { temPermissao } from '@/features/auth/permissions'
import { apiRequest } from '@/lib/api-client'
import { FLAG_DOCUMENTOS_MESTRE, documentosCapacidadesKey } from './documentos-flags'

export interface SondaDocumentos {
  habilitado: boolean
  carregando: boolean
}

export function useSondaDocumentos(): SondaDocumentos {
  const { user } = useAuth()
  const permitido = temPermissao(user?.perfis, 'crm:ver')
  const q = useQuery({
    queryKey: documentosCapacidadesKey,
    queryFn: () => apiRequest<{ habilitada: boolean }>('/v1/documentos/capacidades', { skipAuthRedirect: true }),
    enabled: permitido,
    retry: false,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  })
  return { habilitado: q.isSuccess, carregando: permitido && q.isLoading }
}

export function useFlagsDeNavegacaoDocumentos(): ReadonlySet<string> {
  return new Set(useSondaDocumentos().habilitado ? [FLAG_DOCUMENTOS_MESTRE] : [])
}
